<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22 18H18V4H14V18H10V4H6V18C6 22.25 9.32 25.69 13.5 25.95V44H18.5V25.95C22.68 25.69 26 22.25 26 18V4H22V18ZM32 12V28H37V44H42V4C36.48 4 32 8.48 32 12Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
